import { useGetFaireAcademyPageState } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import {
  FAInnerWrapperColumn,
  FAOuterWrapper,
} from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/styles";
import { OWF_SECTION_NAME } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/types";
import { OpenWithFaireFAQAccordion } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFAQAccordion";
import { Core } from "@faire/design-tokens";
import { trackOpenWithFaireFaireAcademySectionView } from "@faire/web-api--source/events/openWithFaire/view/faireAcademySection";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { SlideIn } from "@faire/web/ui/SlideIn/SlideIn";
import React from "react";

export const FrequentlyAskedQuestions: React.FC = () => {
  const { pageState } = useGetFaireAcademyPageState();
  const ref = useDoActionWhenVisible(() =>
    trackOpenWithFaireFaireAcademySectionView(pageState, OWF_SECTION_NAME.FAQ)
  );

  return (
    <FAOuterWrapper $bgColor={Core.surface.muted} ref={ref}>
      <FAInnerWrapperColumn>
        <SlideIn offset="60px">
          <OpenWithFaireFAQAccordion titleAlignment="left" />
        </SlideIn>
      </FAInnerWrapperColumn>
    </FAOuterWrapper>
  );
};
